module.exports = __webpack_public_path__ + "static/media/dictionary.7ce46aa2.png";